/**
 * FASE2-WIZARD-2b — Lectura del mandato en la ficha.
 *
 * El formulario NO tiene casilla de "Cualquiera": un rango abierto se expresa
 * dejando los dos topes de la barra en los extremos, y un conjunto abierto
 * marcando todas las casillas. En los dos casos se guarda un valor real, nunca vacío, porque
 * un campo vacío sacaría al mandato de las búsquedas que filtren por él.
 *
 * La palabra "Cualquiera" vive AQUÍ, en la lectura: es la forma natural de
 * contarle a quien mira la ficha que esa dimensión no acota nada. Mostrar
 * "De 0 € a más de 25 M€" sería técnicamente correcto y humanamente inútil.
 */

// El formateo del rango y la definición de los grupos son compartidos con el
// formulario (FieldScaleRange): el texto que se lee bajo la barra al publicar y
// el de la ficha salen del mismo sitio, así que no pueden divergir.
import { formatScaleRange } from '../../util/scaleRange';
import { MANDATO_RANGE_GROUPS } from '../../util/mandatoRanges';

export { formatScaleRange, MANDATO_RANGE_GROUPS };

export const MANDATO_LISTING_TYPE = 'mandato-compra';

// Las tres dimensiones de intervalo, con la clave bajo la que se muestran.
// La fila se emite en la clave del MÍNIMO y la del máximo se omite, para que
// el par min/max se lea como una sola línea.
  export const MANDATO_SET_KEYS = ['tiposOperacion', 'modalidades', 'provincias'];

/**
 * Texto de un conjunto (multi-enum) del mandato.
 *
 * @param {Array} enumOptions opciones del field config
 * @param {Array<string>} selected valores guardados
 * @param {Object} intl
 * @returns {string|null} "Cualquiera" si están todas, la lista si no
 */
export const formatSet = (enumOptions = [], selected, intl) => {
  if (!Array.isArray(selected) || selected.length === 0) {
    return null;
  }
  if (selected.length >= enumOptions.length) {
    return intl.formatMessage({ id: 'ListingPage.mandato.cualquiera' });
  }
  const labels = enumOptions
    .filter(o => selected.includes(`${o.option}`))
    .map(o => o.label);
  return labels.length > 0 ? labels.join(', ') : null;
};
